import { lazy, type ReactElement } from 'react';

export interface ProjectDeliveryRouteDefinition {
  capabilityPath: string;
  label: string;
  element: ReactElement;
}

export const ProjectGantt = lazy(() =>
  import('./components/ProjectGantt').then((module) => ({ default: module.ProjectGantt }))
);

export const GuidedProjectList = lazy(() =>
  import('./pages/GuidedProjectList').then((module) => ({ default: module.GuidedProjectList }))
);

export const GuidedProject = lazy(() =>
  import('./pages/GuidedProject').then((module) => ({ default: module.GuidedProject }))
);

export const ProOpsBoard = lazy(() =>
  import('./pages/ProOpsBoard').then((module) => ({ default: module.ProOpsBoard }))
);

export const ProjectContainerBuilder = lazy(() => import('./pages/ProjectContainerBuilder'));

export const PROJECT_DELIVERY_ROUTE_DEFINITIONS: readonly ProjectDeliveryRouteDefinition[] = [
  {
    capabilityPath: '/projects/:projectId/gantt',
    label: 'Project Gantt',
    element: <ProjectGantt />,
  },
  {
    capabilityPath: '/projects/guided',
    label: 'Guided Project List',
    element: <GuidedProjectList />,
  },
  {
    capabilityPath: '/projects/guided/:id',
    label: 'Guided Project',
    element: <GuidedProject />,
  },
  {
    capabilityPath: '/projects/:id/board',
    label: 'Pro Ops Board',
    element: <ProOpsBoard />,
  },
  {
    capabilityPath: '/projects/:id/builder',
    label: 'Project Container Builder',
    element: <ProjectContainerBuilder />,
  },
  {
    capabilityPath: '/projects/guided/:id/builder',
    label: 'Project Container Builder',
    element: <ProjectContainerBuilder />,
  },
];
